import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const StoreCtx = createContext(null);
const DEFAULT = { prelaunch: true, launch_date: null, paypal_enabled: false, shipping: { DE: 4.99, AT: 9.99, EU: 12.99 } };

export const StoreProvider = ({ children }) => {
  const [config, setConfig] = useState(DEFAULT);
  const reload = useCallback(() => api.get("/config").then((r) => setConfig(r.data)), []);
  useEffect(() => { reload(); }, [reload]);
  const value = useMemo(() => ({ ...config, reload }), [config, reload]);
  return <StoreCtx.Provider value={value}>{children}</StoreCtx.Provider>;
};

export const useStore = () => useContext(StoreCtx);
